export const AFFILIATE_SERVICE_URL = process.env.REACT_APP_AFFILIATE_SERVICE_URL;
export const CATALOG_SERVICE_URL = process.env.REACT_APP_CATALOG_SERVICE_URL;
export const ORDER_SERVICE_URL = process.env.REACT_APP_ORDER_SERVICE_URL;
export const CLORIAN_WIDGET_URL = process.env.REACT_APP_CLORIAN_WIDGET_URL;
export const CLORIAN_REGISTRATION_TERMS = process.env.REACT_APP_CLORIAN_REGISTRATION_TERMS_ID;